import type { IsoAndUnixTimestamp } from "../date-time/iso-and-unix";

const statuses = [
    "completed",
    "waiting",
    "active",
    "delayed",
    "failed",
    "prioritized",
    "waiting-children",
    "unknown",
];
type Status = (typeof statuses)[number];

type JobStatus<ReturnValue, Type extends `${string}__JOB_STATUS`> = {
    _type: Type;
    jobId: string;
    status: Status;
    createdAt: IsoAndUnixTimestamp;
    attemptsMade: number;
    startedAt: IsoAndUnixTimestamp | undefined;
    finishedAt: IsoAndUnixTimestamp | undefined;
    failedReason: string | undefined;
    processedBy: string | undefined;
    returnValue: ReturnValue;
};

export { statuses as jobStatuses };
export type { JobStatus, Status as JobStatusStatus };
